<template>
  <div class="container">
    <p class="title">
      Recent Activity
    </p>
    <div class="mt-24"></div>
    <div class="recent-item-container">
      <p class="address">spofnfjwnwdkvmowd=ojwidvjwjvnwdkv</p>
      <p class="view-text">View in Explorer </p>
    </div>
    <div class="recent-item-container">
      <p class="address">spofnfjwnwdkvmowd=ojwidvjwjvnwdkv</p>
      <p class="view-text">View in Explorer </p>
    </div>
    <div class="recent-item-container">
      <p class="address">spofnfjwnwdkvmowd=ojwidvjwjvnwdkv</p>
      <p class="view-text">View in Explorer </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecentActivity',
  data () {
    return {

    }
  }
}
</script>

<style scoped>

.container{
  border-radius: 5px;
  border: 1px solid #D9D9D9;
  background: #FFF;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  height: 260px;
  overflow: auto;
}
.mt-24{
  margin-top: 24px;
}

.title{
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.recent-item-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #D9D9D9;
  background: #FFF;
  padding: 14px 18px;
  width: 100%;
  margin-top: 10px;
}

@media (max-width: 760px) {
  .recent-item-container{
    flex-direction: column;
    gap: 10px;
  }
}

.address{
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.view-text{
  cursor: pointer;
  color: #31E5FF;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

</style>



// WEBPACK FOOTER //
// src/components/dao-community/recent-activity.vue